import { BsPencil } from 'react-icons/bs'
import TableButton from './TableButton'
import { Dropdown, IDropdownItem } from 'components/UI/Dropdown/Dropdown'
import React from 'react'

export default function TableButtonAction({
  selectedRowsCount,
  items,
  isDoorsTable,
  entityType,
}: {
  selectedRowsCount: number
  items?: IDropdownItem[]
  isDoorsTable?: boolean
  entityType?: string
} & Partial<React.ComponentProps<typeof TableButton>>) {
  if (selectedRowsCount === 0) {
    return null
  }

  const defaultEntityType = isDoorsTable ? 'doors' : 'rows'
  const finalEntityType = entityType || defaultEntityType
  const menuLabelText = `Apply to selected ${finalEntityType} (${selectedRowsCount})`

  return (
    <Dropdown
      className={'mt-2'}
      buttonIcon={<BsPencil size={20} />}
      buttonLabel="Actions"
      buttonVariant="primary"
      items={items ?? []}
      menuLabel={menuLabelText}
      disabled={selectedRowsCount === 0}
    />
  )
}
